import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { ProjectSelectModal } from './components/project-select.modal'
import { RouteEnum } from '../../../constants/routes.enum'
import { useProjectStore } from '../../../entities/projects/stores/project.store'
import { useAuth } from '../../../modules/auth/auth.context'
import { ProjectRequiredSections } from '../../constants/common.constants'
import { useModal } from '../../hooks/formik/modal.hook'
import { ModalCenter } from '../../ui/modal/modal-center'

interface UserProjectProviderType {
  children: React.ReactNode
}

export const UserProjectProvider: React.FC<UserProjectProviderType> = ({ children }) => {
  const auth = useAuth()
  const location = useLocation()
  const { t } = useTranslation()
  const [isProjectModalOpen, setIsProjectModalOpen] = React.useState(false)
  const isAuthenticated = auth?.isAuthenticated ?? false
  const project = useProjectStore((state) => state.project)
  const projectsLoaded = useProjectStore((state) => state.isLoaded)
  const projectModal = useModal(false)

  if (!isAuthenticated) {
    return children
  }

  const isProjectRequired = ProjectRequiredSections.find((sectionName) => location.pathname.includes(sectionName))

  if (!project && projectsLoaded && !isProjectModalOpen && isProjectRequired) {
    setIsProjectModalOpen(true)
    projectModal.open()
  }

  if (project && isProjectModalOpen) {
    setIsProjectModalOpen(false)
    projectModal.close()
  }

  const handleChangePage = () => {
    setTimeout(() => {
      setIsProjectModalOpen(false)
      projectModal.close()
    }, 200)
  }

  return (
    <>
      {children}
      <ModalCenter
        closable={false}
        footer={null}
        open={projectModal.opened}
      >
        <ProjectSelectModal />
        <div className="w-100 d-flex justify-content-center mt-3">
          <Link
            onClick={handleChangePage}
            to={RouteEnum.SETTINGS}
          >
            {t('actions.goToSettings')}
          </Link>
        </div>
      </ModalCenter>
    </>
  )
}
